import { PRODUCT_TYPE } from '../constants/product-page-product-details.constants';
import { ProductExtraInfo } from '../public_api';
import { ProductPageStockService } from '../services/product-page-stock.service';

import { getQueryParameterValueFromUrl } from '@core/application/use-cases/url/get-query-parameter-value-from-url.use-case';
import { ProductPublicModels } from '@features/products/product';
import { AttributeType } from '@shared/product/models';

const PATTERN_REGEX = /\b\d{4}\/\d{3}\b/;
const BRACKETS_REGEX = /[[\]]/;

export function getParamsFromUrl(url: string): { color: string; style: string; pelement: string } {
    /** Parámetro de color de producto que viene de las URLs de marketing en los buscadores */
    const cS = getQueryParameterValueFromUrl(url, 'cS');
    const colorId = getQueryParameterValueFromUrl(url, 'colorId');
    const style = getQueryParameterValueFromUrl(url, 'style');
    const pelement = getQueryParameterValueFromUrl(url, 'pelement');
    const color = cS || colorId;

    return { color, style, pelement };
}

export function getImagePathFromProduct(product: ProductPublicModels.PublicProduct): string {
    return product.status?.selectedColor?.medias?.[0]?.path;
}

export function getProductExtraInfoUseCase(
    product: ProductPublicModels.PublicProduct,
    productPageStockService: ProductPageStockService
): ProductExtraInfo {
    const formattedDescription = product?.description?.split(']:')[1]?.trim() || product?.description || '';
    const extractReference = (PATTERN_REGEX.exec(formattedDescription) || [])[0] || '';
    const descriptionWithoutReference = formattedDescription.replace(PATTERN_REGEX, '').trim();
    const splitDescBySquareBracket: string[] = product?.description?.split(BRACKETS_REGEX) || [];
    const coordinatedProductIds = (splitDescBySquareBracket[1]?.split(',') || []).map((s) => s.trim());
    const showStock = productPageStockService.getShowStockSignal(product);

    return {
        isEmptyCoordinatedProducts: coordinatedProductIds.length === 0,
        hasOneOrLessCoordinatedProduct: coordinatedProductIds.length < 2,
        formattedDescription,
        extractReference,
        descriptionWithoutReference,
        isFootWear: product?.productType === PRODUCT_TYPE.FootWear,
        coordinatedProductIds,
        productSpecialCondition: product?.attributes?.filter(
            (attribute) => attribute.type === AttributeType.specialCondition
        ) || [],
        showStock,
    };
}
